import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Компонент TermsOfUsePage - страница "Условия использования"
 */
const TermsOfUsePage = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-200">
      {/* Фоновый узор */}
      <div className="fixed inset-0 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] dark:bg-[radial-gradient(#1f2937_1px,transparent_1px)] [background-size:20px_20px] opacity-20 pointer-events-none"></div>

      {/* Навигация */}
      <Header darkMode={darkMode} toggleDarkMode={toggleDarkMode} />

      {/* Контент */}
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl sm:text-5xl font-bold mb-6">Условия использования</h1>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">1. Принятие условий</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Используя сайт Gensio (далее — «Сайт»), вы соглашаетесь соблюдать настоящие Условия использования и Политику конфиденциальности.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">2. Лицензия на использование</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Мы предоставляем вам ограниченную, неисключительную, безвозмездную лицензию на использование Сайта в личных и коммерческих целях в соответствии с настоящими Условиями.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">3. Ограничения</h2>
          <ul className="list-disc list-inside text-gray-700 dark:text-gray-300">
            <li>Запрещается копировать, изменять или распространять контент Сайта без нашего письменного разрешения.</li>
            <li>Нельзя использовать Сайт для незаконных действий или нарушения прав третьих лиц.</li>
            <li>Запрещается пытаться получить несанкционированный доступ к системам или данным.</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">4. Авторские права и контент</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Весь текст, изображения и другие материалы на Сайте являются нашей собственностью или лицензированы нам. Любое использование без разрешения запрещено.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">5. Отказ от гарантий</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Сайт предоставляется «как есть» без каких-либо гарантий. Мы не гарантируем бесперебойную работу или соответствие Сайта вашим ожиданиям.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">6. Ограничение ответственности</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Мы не несем ответственности за любые убытки, прямые или косвенные, связанные с использованием Сайта.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">7. Изменения условий</h2>
          <p className="text-gray-700 dark:text-gray-300">
            Мы оставляем за собой право изменять настоящие Условия в любое время. Новая версия вступает в силу с момента публикации.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-2">8. Контакты</h2>
          <p className="text-gray-700 dark:text-gray-300">
            По вопросам Условий использования пишите на <a href="mailto:info@gensio.ru" className="text-indigo-600 dark:text-indigo-400">info@gensio.ru</a>
          </p>
        </section>

        <p className="text-sm text-gray-500 dark:text-gray-600">
          Последнее обновление: 29 апреля 2025 г.
        </p>
      </main>

      {/* Футер */}
      <Footer />
    </div>
  );
};

export default TermsOfUsePage;
